import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { isNullOrUndefined } from "util";

import { ResponseInterface } from "../../models/authorization/response-interface";

@Injectable({
    providedIn: "root"
})
export class CompanyService {
    private urlBase: string;
    private headers: HttpHeaders = new HttpHeaders({ "Content-Type": "application/json" });

    constructor(public _http: HttpClient) {
        //this.urlBase = 'http://localhost:3000/';
        this.urlBase = 'https://timesheet-api.e2api.com/companies/'; //Server
    }

    getCompaniesByCategory(categoryId: number): Observable<any> {
        return this._http.get<ResponseInterface>(this.urlBase + `${categoryId}`).pipe(map(data => data));
    }

    getAllCompanies(): Observable<any> {
        return this._http.get<ResponseInterface>(this.urlBase).pipe(map(data => data));
    }

    saveCompany(company: Object){
        return this._http.post<ResponseInterface>(this.urlBase + `save`, company, { headers: this.headers }).pipe(map(data => data));
    }
}